import { ActionsRepository } from "../../infra/repository/actions.repository";
import { Action } from "../domain/actions";

export interface ListActionsOutput {
    workout: string;
    actions: Action[];
}


export class ListActionsUseCase {
    static async execute(workoutId: string): Promise<ListActionsOutput> {
        try {
            const response = await ActionsRepository.list(workoutId);
            if (response.error) return { workout: "", actions: [] };
            return response.data;
        } catch (error) {
            return { workout: "", actions: [] };
        }
    }
}